// extracted by mini-css-extract-plugin
module.exports = {"heroChecks":"HeroChecks_heroChecks__ySXMm","row":"HeroChecks_row__ObnLW","icon":"HeroChecks_icon__6Xs_H","text":"HeroChecks_text__I3MhB"};